import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { wizardChange } from 'slices/WizardSlice';
import { WizardStepContainer } from './partials';
import IntlMessages from '../../../../../util/IntlMessages';
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

const imageText = require('assets/wizard/wizard-mode-text.png');
const imageVisual = require('assets/wizard/wizard-mode-visual.png');

export default function WizardSearchModeStep({ onReady, surfaceVariant }) {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { selectedMode } = useSelector(({ wizard }) => wizard);

  const modeVisual = {
    key: 'visual',
    title: localizeMessage('wizard.mode.visual.title'),
    description: localizeMessage('wizard.mode.visual.description'),
    footer: localizeMessage('wizard.mode.visual.footer'),
    isPreferred: true,
    imageUrl: imageVisual,
  };

  const modeText = {
    key: 'text',
    title: localizeMessage('wizard.mode.text.title'),
    description: localizeMessage('wizard.mode.text.description'),
    footer: ' ',
    isPreferred: false,
    imageUrl: imageText,
  };

  const handleSelectMode = useCallback((modeKey) => {
    dispatch(wizardChange({ selectedMode: modeKey }));
  }, [dispatch]);

  useEffect(() => {
    if (onReady) {
      onReady(!!selectedMode);
    }
  }, [selectedMode, onReady]);

  const ModeCard = ({ mode }) => {
    const isSelected = selectedMode === mode.key;
    return (
      <div
        className={classNames(
          'mode-card',
          { 'mode-card--selected': isSelected },
          { 'mode-card--preferred': mode.isPreferred },
        )}
        onClick={() => handleSelectMode(mode.key)}
      >
        <div className="mode-card__header">
          <Typography variant="h6">{mode.title}</Typography>
        </div>
        <div className="mode-card__body">
          <p className="description">
            {mode.description}
          </p>
          <div className="image-container">
            <img
              className="image"
              src={mode.imageUrl}
              alt={mode.title}
            />
          </div>
        </div>
        <div className="mode-card__footer">
          <p className="caption">
            {mode.footer}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="wizard-step wizard-choose-mode">
      <WizardStepContainer
        title={surfaceVariant === 'cloud-data'
          ? localizeMessage('cloud.dataWizard.searchMode.title')
          : <IntlMessages id="onboarding.chooseMode.title" />}
      >
        <div className="row">
          <div className="col-10 offset-1">
            <p className="sub-header">
              {surfaceVariant === 'cloud-data'
                ? localizeMessage('cloud.dataWizard.searchMode.description')
                : <IntlMessages id="onboarding.chooseMode.subheader" />}
            </p>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-6 mb-4">
            <ModeCard mode={modeText} />
          </div>
          <div className="col-md-6 mb-4">
            <ModeCard mode={modeVisual} />
          </div>
        </div>
      </WizardStepContainer>
    </div>
  );
}

WizardSearchModeStep.propTypes = {
  onReady: PropTypes.func,
  surfaceVariant: PropTypes.oneOf(['legacy', 'cloud-data']),
};

WizardSearchModeStep.defaultProps = {
  onReady: null,
  surfaceVariant: 'legacy',
};
